// extracted by mini-css-extract-plugin
export var brush1 = "quoteImage-module--brush1--n0G9P";
export var brush2 = "quoteImage-module--brush2--37PZx";